// extracted by mini-css-extract-plugin
export default {"contato":"Contato_contato__gWdo-"};